import { Row, Col } from "antd";

export const NalandaSportsArena = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="nalanda-sports-arena">
          Nahil Wijesuriya Donates Rs. 100 Million for Nalanda Sports Arena
        </h1>
      </div>
      <Row>
        <Col xs={24} sm={24} md={24}>
          <p>
            Business tycoon-turned-philanthropist{" "}
            <strong>Nahil Wijesuriya</strong> has donated{" "}
            <strong>Rs. 100 million</strong> towards the{" "}
            <strong>Nalanda Sports Arena</strong>, the second phase of the
            school's Centenary Project.
          </p>

          <p>
            The <strong>Nalanda College Old Boys' Association (NCOBA)</strong>{" "}
            said:
          </p>

          <blockquote>
            <p>
              "His generous contribution marks a landmark milestone for the
              Nalanda Centenary Project and will significantly support the
              development of the Nalanda Sports Arena."
            </p>
          </blockquote>

          <p>
            Wijesuriya has previously donated <strong>Rs. 3 billion</strong> to
            <strong> Trinity College Kandy</strong>,{" "}
            <strong>Rs. 1 billion</strong> to the Little Hearts Project of
            Lady Ridgeway Hospital, <strong>Rs. 600 million</strong> to{" "}
            <strong>S. Thomas' College, Mount Lavinia</strong> for a
            state-of-the-art Information Technology building, and{" "}
            <strong>Rs. 270 million</strong> to construct Bishop's College's new
            A-Level and O-Level building.
          </p>

          <h2>Read More</h2>
          <ul>
            <li>
              <strong>Daily FT: </strong>
              <a
                href="https://www.ft.lk/front-page/Nahil-Wijesuriya-donates-Rs-100-m-for-Nalanda-Sports-Arena/44-794744"
                target="_blank"
                rel="noreferrer"
              >
                Nahil Wijesuriya donates Rs. 100 m for Nalanda Sports Arena
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );
};